import { Button, Divider, Grid, IconButton, InputAdornment, Modal, Paper, SpeedDial, TextField, Typography } from "@mui/material";
import { ReactComponent as OspedaleIcona } from "../../../resources/icone/Ospedale.svg";
import { ReactComponent as LogoCerca } from "../../../resources/icone/Cerca.svg";
import Layer from "leaflet";
import 'leaflet/dist/leaflet.css';
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import images from "../../../resources/export";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { ArrowBack, ArrowForwardIos, FormatListBulleted, Map } from "@mui/icons-material";
import { Redirect } from "../../tools/Redirect";
import { LOGIN } from "../../../global/urlMapping";
import { AuthComp } from "../../../auth/AuthComp";
import { collectionCenterCLSelector, geoLocationsCollectionCenterCLSelector } from "../../../modules/screeningColonRetto/selectors";
import { getCollectionCenterByLevelCLAction } from "../../../modules/screeningColonRetto/actions";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-regular-svg-icons";

export const Strutture = () => {
    const dispatch = useDispatch();

    const collectionCenter = useSelector(collectionCenterCLSelector);
    const geoLocationsCollectionCenterCL = useSelector(geoLocationsCollectionCenterCLSelector)
    const [isEnableMap, setIsEnableMap] = useState(false);
    const [viewStruttura, setViewStruttura] = useState({ struttura: {}, state: false });

    useEffect(() => {
        dispatch(getCollectionCenterByLevelCLAction())
    }, [dispatch]);


    const iconPerson = new Layer.Icon({
        iconUrl: require("../../../resources/icone/RedPoi.png"),
        iconRetinaUrl: require("../../../resources/icone/RedPoi.png"),
        iconAnchor: new Layer.Point(12, 41),
        popupAnchor: new Layer.Point(1, -34),
        shadowUrl: null,
        shadowSize: null,
        shadowAnchor: null,
        iconSize: new Layer.Point(25, 41),
        className: "",
    });

    const [inputSearch, setInputSearch] = useState("");

    const handleChange = (e) => {
        let lowerCaseText = e.target.value.toLowerCase();
        setInputSearch(lowerCaseText);
    }

    const findcenter = () => {
        let sumLat = 0;
        let sumLong = 0;
        let i = 0;
        geoLocationsCollectionCenterCL?.value?.forEach((marker) => {
            sumLat += Number(marker.latitudine);
            sumLong += Number(marker.longitudine);
            i++;
        })

        return [(sumLat / i), (sumLong / i)]

    }


    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <AuthComp fallback={< Redirect link={LOGIN} />} >
            <Box
                className="bg"
                sx={{
                    height: "100%",
                    minHeight: {
                        xs: "calc(100vh - (600px + 150px))",
                        md: "calc(100vh - 150px)",
                    },
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {collectionCenter?.value && collectionCenter?.value.length !== 0 && (
                    <>

                        <Box
                            sx={{
                                height: "100%",
                                position: "relative",
                                width: { xs: "100%", md: "80%" },
                                display: "flex",
                                overflow: "auto",
                                flexDirection: "column",
                                margin: "0 auto",
                            }}
                        >

                            {isEnableMap ? (
                                <Box
                                    sx={{
                                        width: { xs: "100%", md: "90%" },
                                        height: "100%",
                                        borderRadius: "15px",
                                        margin: "0 auto",
                                        display: "flex",
                                        flexDirection: "column",
                                        backgroundColor: "transparent",
                                    }}
                                >
                                    <Grid container wrap="nowrap" >
                                        <Grid item xs zeroMinWidth>

                                            <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                                <Typography
                                                    component='h1'
                                                    sx={{
                                                        color: "#005397",
                                                        margin: "auto",
                                                        textAlign: "center",
                                                        fontSize: { xs: "25px", md: "40px" },
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    Strutture dove ritirare il tuo KIT
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                    <Box
                                        sx={{
                                            height: "100%",
                                            margin: "auto",
                                            width: "100%",
                                            display: "flex",
                                        }}
                                    >
                                        <MapContainer
                                            style={{
                                                height: "500px",
                                                width: "95%",
                                                margin: "0 auto",
                                            }}
                                            center={findcenter()}
                                            zoom={9}
                                            scrollWheelZoom={false}
                                        >
                                            <TileLayer
                                                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            />
                                            {
                                                geoLocationsCollectionCenterCL?.value?.map((marker, index) => {
                                                    return (
                                                        marker.latitudine !== null && marker.longitudine &&
                                                        <Marker
                                                            key={index}
                                                            position={[
                                                                marker.latitudine,
                                                                marker.longitudine,
                                                            ]}
                                                            icon={iconPerson}
                                                        >
                                                            <Popup className="myPopup">
                                                                <Box
                                                                    sx={{
                                                                        // height: "350px",
                                                                        backgroundColor: "transparent",
                                                                        display: "flex",
                                                                        flexDirection: "column",
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        sx={{
                                                                            //height: "50px",
                                                                            color: "#005397",
                                                                            fontSize: "23px",
                                                                            fontWeight: 600,
                                                                            lineHeight: "1",
                                                                            textAlign: "center",
                                                                        }}
                                                                    >
                                                                        {marker?.description}
                                                                    </Typography>
                                                                    <Typography
                                                                        sx={{
                                                                            // height: "50px",
                                                                            color: "#005397",
                                                                            fontSize: "20px",
                                                                            fontWeight: 500,
                                                                            textAlign: "center",
                                                                            marginTop: "5px"
                                                                        }}
                                                                    >
                                                                        {marker?.address}
                                                                    </Typography>
                                                                    {marker?.telephone &&
                                                                        <Typography
                                                                            sx={{
                                                                                //  height: "20px",
                                                                                color: "#005397",
                                                                                fontSize: "20px",
                                                                                fontWeight: 500,
                                                                                textAlign: "center",
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon icon={faPhone} style={{ height: '20px', width: '60px', margin: 'auto', color: '#005397', alignItems: "center", justifyContent: "center" }} />
                                                                            {marker?.telephone}
                                                                        </Typography>
                                                                    }
                                                                    {marker?.workingTime &&
                                                                        <Typography
                                                                            sx={{
                                                                                // height: "50px",
                                                                                color: "#005397",
                                                                                fontSize: "18px",
                                                                                fontWeight: 400,
                                                                                textAlign: "center",
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon icon={faClock} style={{ height: '20px', width: '60px', margin: 'auto', color: '#005397' }} />
                                                                            Orari di apertura: <br />
                                                                            {marker?.workingTime}
                                                                        </Typography>
                                                                    }
                                                                    <Button variant='contained' sx={{ borderRadius: '20px !important', backgroundColor: '#005397', height: '30px', width: '90%', margin: '10px auto' }} onClick={() => window.open('https://www.google.com/maps/dir/?api=1&destination=' + marker.latitudine + ',' + marker.longitudine)}>
                                                                        <Typography sx={{ color: 'white', fontWeight: 600, textAlign: 'center' }}>
                                                                            Indicazioni
                                                                        </Typography>
                                                                    </Button>
                                                                </Box>
                                                            </Popup>
                                                        </Marker>
                                                    );
                                                })}
                                        </MapContainer>
                                    </Box>
                                </Box>
                            ) : (
                                <>
                                    <Grid container wrap="nowrap" >
                                        <Grid item xs zeroMinWidth>

                                            <Box sx={{ width: "100%", height: "150px", display: "flex" }}>
                                                <Typography
                                                    component='h1'
                                                    sx={{
                                                        color: "#005397",
                                                        margin: "auto",
                                                        textAlign: "center",
                                                        fontSize: { xs: "25px", md: "40px" },
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    Strutture dove ritirare il tuo KIT
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </Grid>

                                    <Grid
                                        container
                                        sx={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "20px auto",
                                            backgroundColor: "transparent",
                                            justifyContent: "center"
                                        }}
                                    >
                                        <TextField
                                            onChange={handleChange}
                                            variant="outlined"
                                            name="inputSearch"
                                            label="Cerca struttura"
                                            value={inputSearch}
                                            autoFocus
                                            sx={{ width: { xs: "50%", md: "40%" }, mb: "10px", backgroundColor: "white" }}
                                            placeholder="Cerca struttura"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end" style={{ width: "10%", }}>
                                                        <LogoCerca />
                                                    </InputAdornment>
                                                ),
                                                sx: { borderRadius: 3 },
                                            }}
                                            autoComplete="off"
                                        />
                                    </Grid>

                                    <Grid
                                        container
                                        sx={{
                                            width: "100%",
                                            display: "flex",
                                            margin: "20px auto",
                                            backgroundColor: "transparent",
                                        }}
                                    >
                                        {geoLocationsCollectionCenterCL?.value && geoLocationsCollectionCenterCL?.value?.filter((struttura) => {
                                            if (inputSearch === "") {
                                                return true;
                                            }
                                            else {
                                                return (struttura?.address.toLowerCase()?.includes(inputSearch) || struttura?.description?.toLowerCase()?.includes(inputSearch));
                                            }
                                        })?.map((struttura, index) => (

                                            <IconButton
                                                key={index}
                                                sx={{ width: "100%", display: "flex" }}
                                                onClick={() => setViewStruttura({ struttura: struttura, state: true })}
                                                disableRipple
                                                disableTouchRipple
                                                disableFocusRipple
                                            >
                                                <Box
                                                    sx={{
                                                        minHeight: { xs: "200px", md: "130px" },
                                                        backgroundColor: "transparent",
                                                        width: "100%",
                                                        margin: "15px auto",
                                                        display: "flex",
                                                        borderBottom: "0.5px solid #005397",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            width: "30%",
                                                            minHeight: "100px",
                                                            backgroundColor: "transparent",
                                                            display: { xs: "none", md: "flex" },
                                                            margin: "auto",
                                                        }}
                                                    >
                                                        <OspedaleIcona
                                                            style={{ height: "70px", margin: "auto" }}
                                                        />
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            width: "30%",
                                                            minHeight: "100px",
                                                            backgroundColor: "transparent",
                                                            display: { xs: "flex", md: "none" },
                                                            margin: "auto",
                                                        }}
                                                    >
                                                        <OspedaleIcona
                                                            style={{ height: "50px", margin: "auto" }}
                                                        />
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            width: "90%",
                                                            minHeight: "100px",
                                                            backgroundColor: "transparent",
                                                            display: "flex",
                                                            margin: "auto",
                                                            flexDirection: "column",
                                                        }}
                                                    >
                                                        <Typography
                                                            component='h2'
                                                            sx={{
                                                                minHeight: "50px",
                                                                paddingLeft: "5px",
                                                                fontSize: { xs: "25px", md: "30px" },
                                                                fontWeight: 600,
                                                                display: "flex",
                                                                color: "#005397",
                                                            }}
                                                        >
                                                            {struttura.description}
                                                        </Typography>
                                                        <Typography
                                                            component='h3'
                                                            sx={{
                                                                paddingLeft: "5px",
                                                                fontSize: { xs: "18px", md: "25px" },
                                                                fontWeight: 400,
                                                                minHeight: "50px",
                                                                display: "flex",
                                                                color: "#005397",
                                                            }}
                                                        >
                                                            {struttura.address}
                                                        </Typography>
                                                    </Box>
                                                    <Box
                                                        sx={{
                                                            width: "10%",
                                                            height: "100px",
                                                            backgroundColor: "transparent",
                                                            margin: "auto",
                                                        }}
                                                    >
                                                        <ArrowForwardIos sx={{ fontSize: "{ xs: '25px', md: '30px' }", margin: "auto", marginRight: "0px", color: "#005397", height: "50px" }} />
                                                    </Box>
                                                </Box>
                                            </IconButton>

                                        ))}
                                    </Grid>
                                </>
                            )}
                        </Box>
                    </>
                )}
                <SpeedDial
                    onClick={() => setIsEnableMap(!isEnableMap)}
                    ariaLabel="bottone per aprire la mappa"
                    sx={{
                        bottom: 40,
                        marginBottom: "20px",
                        position: "sticky",
                        alignSelf: "flex-end",
                        right: 40,
                    }}
                    icon={isEnableMap ? <FormatListBulleted /> : <Map />}
                />
                <Modal
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick')
                            setViewStruttura({ struttura: {}, state: false })
                    }}
                    open={viewStruttura.state}
                    sx={{ display: "flex", background: "transparent !important" }}
                >
                    <Box
                        sx={{
                            height: "90%",
                            width: { xs: "80%", md: "40%" },
                            margin: "auto",
                            backgroundColor: "white",
                        }}
                    >
                        <Box
                            sx={{
                                height: "350px",
                                position: "relative",
                                zIndex: 0,
                                borderBottomRightRadius: "35px",
                                backgroundColor: "transparent",
                                borderBottomLeftRadius: "35px",
                                width: "100%",
                            }}
                        >
                            <img
                                src={images.illustrazioni.schedaOspedale}
                                style={{
                                    width: '100%',
                                    //   height: "320px",
                                    borderBottomRightRadius: "30px",
                                    borderBottomLeftRadius: "30px",
                                }}
                                alt="immagine di sfondo"
                            />
                        </Box>
                        <Paper
                            elevation={6}
                            sx={{
                                height: "50vh",
                                borderRadius: "20px",
                                display: "flex",
                                position: "relative",
                                width: "80%",
                                zIndex: 1,
                                margin: "-160px auto",
                            }}
                        >
                            <Box
                                sx={{
                                    height: { md: "100%", xs: "100%" },
                                    width: "90%",
                                    margin: "auto",
                                    display: "flex",
                                    flexDirection: "column",
                                }}
                            >
                                <IconButton
                                    sx={{
                                        height: "30px",
                                        width: "100px",
                                        display: "flex",
                                        backgroundColor: "transparent",
                                        alignItems: "flex-start",
                                        marginBottom: "1vh"
                                    }}
                                    onClick={() => setViewStruttura({ struttura: {}, state: false })}
                                    edge={"start"}
                                    disableRipple
                                    disableTouchRipple
                                    disableFocusRipple
                                >
                                    <ArrowBack sx={{ color: "#005397" }} />
                                    <Typography sx={{ color: "#005397", fontWeight: 600 }}>
                                        Indietro
                                    </Typography>
                                </IconButton>
                                <Typography
                                    sx={{
                                        //  height: "20%",
                                        paddingLeft: "5px",
                                        fontSize: { xs: "13px", md: "15px" },
                                        fontWeight: 700,
                                        display: "flex",
                                        color: "#005397",
                                        backgroundColor: 'transparent',
                                        marginTop: '2vh',
                                        marginBottom: '2vh',
                                        textTransform: 'downcase',
                                        textAlign: 'center',
                                        justifyContent: "center",
                                    }}
                                >
                                    {viewStruttura?.struttura?.description}
                                </Typography>
                                <Typography
                                    sx={{
                                        //  height: "20%",
                                        paddingLeft: "5px",
                                        fontSize: { xs: "13px", md: "15px" },
                                        fontWeight: 700,
                                        display: "flex",
                                        color: "#005397",
                                        backgroundColor: 'transparent',
                                        marginTop: '2vh',
                                        textTransform: 'downcase',
                                        textAlign: 'center',
                                        justifyContent: "center",
                                    }}
                                >{viewStruttura?.struttura?.address}
                                </Typography>
                                <Box sx={{ width: "100%", display: "flex", paddingTop: "2vh", paddingBottom: "2vh", marginTop: '2vh' }}>
                                    <Button
                                        onClick={() => window.open('https://www.google.com/maps/dir/?api=1&destination=' + viewStruttura.struttura.latitudine + ',' + viewStruttura.struttura.longitudine)}
                                        variant="contained"
                                        disableRipple
                                        disableFocusRipple
                                        disableTouchRipple
                                        sx={{
                                            backgroundColor: "#005397",
                                            margin: "auto",
                                            height: "50px",
                                            width: "100%",
                                            borderRadius: "20px !important",
                                            color: "white",
                                            fontSize: '18px',
                                            fontWeight: 600,
                                            "&:hover": { backgroundColor: "#DCEEFE", borderColor: '#DCEEFE', borderWidth: '2px', color: "white" },
                                        }}
                                    >
                                        Indicazioni

                                    </Button>
                                </Box>
                                <Divider sx={{ width: '100%', marginBottom: '10px' }} />
                                <Box sx={{ width: '100%', marginTop: '20px', marginBottom: '10px' }}>
                                    <Grid container rowSpacing={3} columnSpacing={{ xs: 2, sm: 3, md: 4 }}>
                                        {
                                            <>
                                                <Grid item xs={2}>
                                                    <FontAwesomeIcon icon={faPhone} style={{ height: '20px', width: '60px', margin: 'auto', color: '#005397' }} />
                                                </Grid>
                                                <Grid item xs={10}>
                                                    <Typography sx={{ color: '#005397', fontSize: { xs: "13px", md: "15px" }, margin: 'auto', fontWeight: 600 }}>
                                                        {viewStruttura?.struttura?.telephone ?? '--'}
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }
                                        {
                                            <>
                                                <Grid item xs={2}>
                                                    <FontAwesomeIcon icon={faClock} style={{ height: '20px', width: '60px', margin: 'auto', color: '#005397' }} />
                                                </Grid>
                                                <Grid item xs={10}>
                                                    <Typography sx={{ color: '#005397', fontSize: { xs: "13px", md: "15px" }, margin: 'auto', fontWeight: 'bold' }}>
                                                        {viewStruttura?.struttura?.workingTime ?? '--'}
                                                    </Typography>
                                                </Grid>
                                            </>
                                        }
                                    </Grid>
                                </Box>
                            </Box>
                        </Paper>
                    </Box>
                </Modal>
            </Box>
        </AuthComp>
    );
};